export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9215.bb1d4a8c.jpg";